
import './App.css';
import 'bootswatch/dist/materia/bootstrap.min.css';
import Search from "./search"

function App() {
  return (
    <div className="container mt-5">
     <Search/>
    </div>
  );
}

export default App;
